import { ParselyConfig } from "@voxmedia/duet-context/context/config-context";

const config: ParselyConfig = {
  tagsToInverse: [],
  enableTraining: true,
  enableArticleRecirc: true,
};

export default config;
